import React, { Component } from 'react';
import './CheckoutConfirm.scss';
import { ProductConsumer } from '../../../../Context';

class CheckoutConfirm extends Component {
  render() {
    return (
      <section>
        <ProductConsumer>
          {value => {
            const { checkoutOff } = value;
            const { confirmDisplayed } = value;
            if (confirmDisplayed) {
              return (
                <div>
                  <div className='confirm__message'>
                    <p className='bold'>Payment Confirmed!</p>
                    <p className='confirm__message__smaller'>
                      Congrats on your new corgi.
                    </p>
                    <p className='confirm__message__smaller'>
                      You'll receive an email with the details regarding your
                      order.
                    </p>
                  </div>
                  <button className='btn' onClick={checkoutOff}>
                    Return to main page
                  </button>
                </div>
              );
            }
          }}
        </ProductConsumer>
      </section>
    );
  }
}

export default CheckoutConfirm;
